import React from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import { lassoForm } from '@bd/bdui-forms';
import { Redirect } from '@bd/bdcore-named-routes';
import { SanitizeHtml } from '@bd/bdcore-utilities';

import Fields from './Fields';
import { forms, successForms } from '../../styles';

class FormContact extends React.Component {
  constructor(props) {
    super(props);

    const { formApi, formName, formLabel } = props;

    formApi.setValue('formName', formName);
    formApi.setValue('formLabel', formLabel);

    this.state = {};
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.success && !this.props.success) {
      this.props.onSuccess();
    }
  }

  getError = field => {
    const { formApi } = this.props;
    return get(formApi, `touched.${field}`) && get(formApi, `errors.${field}`);
  }

  getErrorClass = field => {
    const { formApi } = this.props;
    if (get(formApi, `touched.${field}`) && get(formApi, `errors.${field}`)) {
      return 'is-invalid';
    }

    return null;
  }

  render() {
    const {
      className,
      success,
      redirectRoute,
      fields,
      formApi,
      formName,
      formLabel,
      thankYou,
    } = this.props;

    const defaultThankYou = '<p></p><div style="text-align: center;"><b>THANK YOU</b></div><div style="text-align: center;">For contacting us. We have received your message and will respond as soon as possible.</div><p></p>';
    const thankYouText = thankYou || defaultThankYou;

    if (success) {
      return (
        <div>
          {
            redirectRoute &&
            <Redirect
              name={redirectRoute}
            />
          }
          {
            !redirectRoute &&
            <div className={`${successForms} Form_success`} dangerouslySetInnerHTML={SanitizeHtml(thankYouText)} />
          }
        </div>
      );
    }

    return (
      <div className={[forms, className].filter(v => v).join(' ')}>
        <div className="form-row">
          {
            fields.map(config => {
              const FieldComponent = Fields[config.type];
              if (!FieldComponent) {
                return (
                  <div className="form-col" key={config.label}>
                    <label htmlFor="missing">{config.label}</label>
                    <div className="Form__missingField">{`Field type "${config.type}" does not exist`}</div>
                  </div>
                );
              }
              return (
                <FieldComponent
                  {...config}
                  key={config.label}
                  getErrorClass={this.getErrorClass}
                  getError={this.getError}
                  formName={formName}
                  formLabel={formLabel}
                  formApi={formApi}
                />
              );
            })
          }
        </div>
        <div className="Button_wrapper">
          <button type="submit" className="Btn_submit">Submit<span className="ArrowButton_image" /></button>
        </div>
      </div>
    );
  }
}

FormContact.propTypes = {
  className: PropTypes.string,
  formName: PropTypes.string.isRequired,
  formLabel: PropTypes.string.isRequired,
  formApi: PropTypes.object.isRequired,
  success: PropTypes.bool,
  onSuccess: PropTypes.func,
  redirectRoute: PropTypes.string,
  thankYou: PropTypes.string,
  fields: PropTypes.arrayOf(PropTypes.object).isRequired,
};

FormContact.defaultProps = {
  className: undefined,
  success: undefined,
  onSuccess: () => { },
  redirectRoute: undefined,
  warrantyAreaHandler: undefined,
  thankYou: undefined,
};

export default lassoForm()(FormContact);



// WEBPACK FOOTER //
// ./src/components/Forms/Form.js